import { ConstraintDrillFracInterferenceDetailBase } from './base/constraint-drill-frac-interference-detail-base';

export class ConstraintDrillFracInterferenceDetail extends ConstraintDrillFracInterferenceDetailBase { }